export default class Marquee {

  constructor(selector, items = [], index = 0, pad = 0) {
    this.items = items;
    this.index = index;

    // Check the selector
    this.element = document.querySelector(selector);
    if (!this.element) throw new Error('Marquee: Selector is invalid.');

    // Animating state
    this.animating = false;

    // Get the first element
    this.currentElement = this.element.firstChild;
    this.currentElement.innerHTML = this.items[this.index];
    this.currentText = this.items[this.index];
    this.innerElementType = this.currentElement.tagName;

    // Get inner height
    this.innerHeight = this.currentElement.scrollHeight + pad;

    // Style steups
    this.element.style.position = 'absolute';
    this.element.style.overflow = 'hidden';
    this.element.style.width = '100%';
    this.element.style.height = `${this.innerHeight}px`;
  }

  change(direction = 1) {
    [...this.element.querySelectorAll('*')].forEach(e => e.remove());
    clearTimeout(this.renderTimeout);

    let topEl = this.currentElement.cloneNode();
    topEl.innerHTML = this.currentText;
    topEl.style.position = 'absolute';
    topEl.style.transition = 'all 400ms';
    topEl.style.height = `${this.innerHeight}px`
    topEl.style.top = '0px';
    this.element.append(topEl);

    let bottomEl = this.currentElement.cloneNode();
    bottomEl.innerHTML = this.items[this.index];
    bottomEl.style.position = 'absolute';
    bottomEl.style.transition = 'all 400ms';
    bottomEl.style.height = `${this.innerHeight}px`;
    if (direction === -1) {
      bottomEl.style.top = `-${this.innerHeight}px`;
    } else {
      bottomEl.style.top = `${this.innerHeight}px`;
    }
    this.element.append(bottomEl);
    this.currentText = this.items[this.index];
    this.renderTimeout = setTimeout(() => {
      if (direction === -1) {
        topEl.style.top = `${this.innerHeight}px`;
      } else {
        topEl.style.top = `-${this.innerHeight}px`;
      }
      bottomEl.style.top = `0px`;
    }, 25);
  }

  goto(text) {
    let nextIndex = this.items.indexOf(text);
    let scrollDirection = nextIndex < this.index ? -1 : 1;
    this.index = nextIndex || 0;
    this.change(scrollDirection);
  }
}



// WEBPACK FOOTER //
// ./source/javascript/utilities/marquee.js